export default {"src":"/_next/static/media/ehr-systems.d9ba6e94.svg","height":512,"width":576,"blurWidth":0,"blurHeight":0};